import React from 'react'
import Styles from '../css/AddHcpSuccess.module.css'
import Icon from '../../../components/Icon/Icon';

export default function AddHcpSuccess(props) {
    return (
        <div className={Styles.editScreen}>
            <div className={Styles.wrapper}>
                <div className={Styles.title}>
                    <div></div>
                    <div>Add Professional</div>
                    <div className={Styles.close} onClick={() => {props.close()}}><span aria-hidden="true">×</span></div>
                </div>
                <div className={Styles.body}>
                    <div className={Styles.toprow}>
                        <div className={[Styles.set, Styles.mainTitle].join(' ')}>
                            <div className={Styles.titleText}><Icon name="check-circle" /></div>
                        </div>
                    </div>
                    <div className={Styles.middlerow}>
                        <div className={Styles.set}>
                            <div className={Styles.contentTitle}>Thank you!</div>
                            <div className={Styles.content}>Your request has been submitted.</div>
                        </div>
                    </div>
                    <div className={Styles.buttonRow}>
                        <div id={Styles.submit} onClick={() => {props.close()}}>CLOSE</div>
                    </div>
                </div>
            </div>
        </div>
    )
}